// NOTE: Generated by `generate-localizations.ps1`
//       The object keys are an index of languages supported by the product.
//       The values are for informational purposes only.

const productSupportedLocales: { [code: string]: string } = {
	hr: 'Croatian',
	sv: 'Swedish',
	fr: 'French',
	pl: 'Polish',
	da: 'Danish',
	hi: 'Hindi',
	hu: 'Hungarian',
	es: 'Spanish',
	ja: 'Japanese',
	de: 'German',
	pt: 'Portuguese',
	tr: 'Turkish',
	en: 'English',
	it: 'Italian',
	zh: 'Chinese',
	fi: 'Finnish',
	bg: 'Bulgarian',
	nb: 'Norwegian Bokmål',
	el: 'Greek',
	nl: 'Dutch',
	th: 'Thai'
};

export default productSupportedLocales;
